import { apiClient, type TaxCategoryEntity } from '@/libs/api'

export type FetchTaxCategoryQuery = {
  tenantKey: string
  taxCategoryId: number
}

export const fetchTaxCategory = async (
  { tenantKey, taxCategoryId }: FetchTaxCategoryQuery,
  signal?: AbortSignal
): Promise<TaxCategoryEntity> => {
  const { data } = await apiClient
    ._tenant(tenantKey)
    .tax_categories._id(taxCategoryId)
    .$get({ config: { signal } })
  return data
}
